import React from 'react'

import { ButtonGroupEl } from './elements'
import Link from '../Link'

const ButtonGroup = ({ items }) => {
  return (
    <ButtonGroupEl>
      {items.map(({ altText, src, link }) => {
        return (
          <div key={`ButtonGroup:${link}`}>
            <Link to={link}>
              <img src={src} alt={altText} title={altText} />
            </Link>
          </div>
        )
      })}
    </ButtonGroupEl>
  )
}

export default ButtonGroup
